/* tslint:disable */
/* eslint-disable */
/**
 * Farseer API
 * Farseer API
 *
 * The version of the OpenAPI document: 3
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import * as runtime from '../runtime';
import { CreateSheetRowRequestToJSON, CreatedSheetRowRepresentationFromJSON, DuplicateSheetRowRequestToJSON, MaterializeSheetRowHierarchyRequestToJSON, MoveSheetRowRequestToJSON, SearchSheetRowHierarchyRequestToJSON, SearchSheetRowSearchResultRepresentationFromJSON, SheetRowEntityActionsRepresentationFromJSON, SheetRowRepresentationFromJSON, UpdateSheetRowRequestToJSON, } from '../models';
/**
 *
 */
var SheetRowsApi = /** @class */ (function (_super) {
    __extends(SheetRowsApi, _super);
    function SheetRowsApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * Delete sheet row
     */
    SheetRowsApi.prototype._deleteRaw = function (requestParameters) {
        return __awaiter(this, void 0, Promise, function () {
            var queryParameters, headerParameters, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.sheetRowId === null || requestParameters.sheetRowId === undefined) {
                            throw new runtime.RequiredError('sheetRowId', 'Required parameter requestParameters.sheetRowId was null or undefined when calling _delete.');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        return [4 /*yield*/, this.request({
                                path: "/sheetRows/{sheetRowId}".replace("{".concat('sheetRowId', "}"), encodeURIComponent(String(requestParameters.sheetRowId))),
                                method: 'DELETE',
                                headers: headerParameters,
                                query: queryParameters,
                            })];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.VoidApiResponse(response)];
                }
            });
        });
    };
    /**
     * Delete sheet row
     */
    SheetRowsApi.prototype._delete = function (sheetRowId) {
        return __awaiter(this, void 0, Promise, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this._deleteRaw({ sheetRowId: sheetRowId })];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Find all sheet row actions
     */
    SheetRowsApi.prototype.actionsRaw = function () {
        return __awaiter(this, void 0, Promise, function () {
            var queryParameters, headerParameters, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        queryParameters = {};
                        headerParameters = {};
                        return [4 /*yield*/, this.request({
                                path: "/sheetRows/entityActions",
                                method: 'GET',
                                headers: headerParameters,
                                query: queryParameters,
                            })];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) {
                                return jsonValue.map(SheetRowEntityActionsRepresentationFromJSON);
                            })];
                }
            });
        });
    };
    /**
     * Find all sheet row actions
     */
    SheetRowsApi.prototype.actions = function () {
        return __awaiter(this, void 0, Promise, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.actionsRaw()];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Create sheet rowrow
     */
    SheetRowsApi.prototype.createRaw = function (requestParameters) {
        return __awaiter(this, void 0, Promise, function () {
            var queryParameters, headerParameters, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.createSheetRowRequest === null || requestParameters.createSheetRowRequest === undefined) {
                            throw new runtime.RequiredError('createSheetRowRequest', 'Required parameter requestParameters.createSheetRowRequest was null or undefined when calling create.');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        headerParameters['Content-Type'] = 'application/json';
                        return [4 /*yield*/, this.request({
                                path: "/sheetRows",
                                method: 'POST',
                                headers: headerParameters,
                                query: queryParameters,
                                body: CreateSheetRowRequestToJSON(requestParameters.createSheetRowRequest),
                            })];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return CreatedSheetRowRepresentationFromJSON(jsonValue); })];
                }
            });
        });
    };
    /**
     * Create sheet rowrow
     */
    SheetRowsApi.prototype.create = function (createSheetRowRequest) {
        return __awaiter(this, void 0, Promise, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.createRaw({ createSheetRowRequest: createSheetRowRequest })];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Duplicate sheet row
     */
    SheetRowsApi.prototype.duplicateRaw = function (requestParameters) {
        return __awaiter(this, void 0, Promise, function () {
            var queryParameters, headerParameters, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.sheetRowId === null || requestParameters.sheetRowId === undefined) {
                            throw new runtime.RequiredError('sheetRowId', 'Required parameter requestParameters.sheetRowId was null or undefined when calling duplicate.');
                        }
                        if (requestParameters.duplicateSheetRowRequest === null ||
                            requestParameters.duplicateSheetRowRequest === undefined) {
                            throw new runtime.RequiredError('duplicateSheetRowRequest', 'Required parameter requestParameters.duplicateSheetRowRequest was null or undefined when calling duplicate.');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        headerParameters['Content-Type'] = 'application/json';
                        return [4 /*yield*/, this.request({
                                path: "/sheetRows/{sheetRowId}/duplicate".replace("{".concat('sheetRowId', "}"), encodeURIComponent(String(requestParameters.sheetRowId))),
                                method: 'POST',
                                headers: headerParameters,
                                query: queryParameters,
                                body: DuplicateSheetRowRequestToJSON(requestParameters.duplicateSheetRowRequest),
                            })];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return CreatedSheetRowRepresentationFromJSON(jsonValue); })];
                }
            });
        });
    };
    /**
     * Duplicate sheet row
     */
    SheetRowsApi.prototype.duplicate = function (sheetRowId, duplicateSheetRowRequest) {
        return __awaiter(this, void 0, Promise, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.duplicateRaw({
                            sheetRowId: sheetRowId,
                            duplicateSheetRowRequest: duplicateSheetRowRequest,
                        })];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Fetch sheet row by id
     */
    SheetRowsApi.prototype.getRaw = function (requestParameters) {
        return __awaiter(this, void 0, Promise, function () {
            var queryParameters, headerParameters, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.sheetRowId === null || requestParameters.sheetRowId === undefined) {
                            throw new runtime.RequiredError('sheetRowId', 'Required parameter requestParameters.sheetRowId was null or undefined when calling get.');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        return [4 /*yield*/, this.request({
                                path: "/sheetRows/{sheetRowId}".replace("{".concat('sheetRowId', "}"), encodeURIComponent(String(requestParameters.sheetRowId))),
                                method: 'GET',
                                headers: headerParameters,
                                query: queryParameters,
                            })];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return SheetRowRepresentationFromJSON(jsonValue); })];
                }
            });
        });
    };
    /**
     * Fetch sheet row by id
     */
    SheetRowsApi.prototype.get = function (sheetRowId) {
        return __awaiter(this, void 0, Promise, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getRaw({ sheetRowId: sheetRowId })];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Find all sheet rows
     */
    SheetRowsApi.prototype.listRaw = function () {
        return __awaiter(this, void 0, Promise, function () {
            var queryParameters, headerParameters, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        queryParameters = {};
                        headerParameters = {};
                        return [4 /*yield*/, this.request({
                                path: "/sheetRows",
                                method: 'GET',
                                headers: headerParameters,
                                query: queryParameters,
                            })];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return jsonValue.map(SheetRowRepresentationFromJSON); })];
                }
            });
        });
    };
    /**
     * Find all sheet rows
     */
    SheetRowsApi.prototype.list = function () {
        return __awaiter(this, void 0, Promise, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.listRaw()];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * materialize sheet row hierarchy
     */
    SheetRowsApi.prototype.materializeRaw = function (requestParameters) {
        return __awaiter(this, void 0, Promise, function () {
            var queryParameters, headerParameters, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.materializeSheetRowHierarchyRequest === null ||
                            requestParameters.materializeSheetRowHierarchyRequest === undefined) {
                            throw new runtime.RequiredError('materializeSheetRowHierarchyRequest', 'Required parameter requestParameters.materializeSheetRowHierarchyRequest was null or undefined when calling materialize.');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        headerParameters['Content-Type'] = 'application/json';
                        return [4 /*yield*/, this.request({
                                path: "/sheetRows/materialize",
                                method: 'POST',
                                headers: headerParameters,
                                query: queryParameters,
                                body: MaterializeSheetRowHierarchyRequestToJSON(requestParameters.materializeSheetRowHierarchyRequest),
                            })];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.VoidApiResponse(response)];
                }
            });
        });
    };
    /**
     * materialize sheet row hierarchy
     */
    SheetRowsApi.prototype.materialize = function (materializeSheetRowHierarchyRequest) {
        return __awaiter(this, void 0, Promise, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.materializeRaw({ materializeSheetRowHierarchyRequest: materializeSheetRowHierarchyRequest })];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Sort sheetRows
     */
    SheetRowsApi.prototype.moveRaw = function (requestParameters) {
        return __awaiter(this, void 0, Promise, function () {
            var queryParameters, headerParameters, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.sheetRowId === null || requestParameters.sheetRowId === undefined) {
                            throw new runtime.RequiredError('sheetRowId', 'Required parameter requestParameters.sheetRowId was null or undefined when calling move.');
                        }
                        if (requestParameters.moveSheetRowRequest === null || requestParameters.moveSheetRowRequest === undefined) {
                            throw new runtime.RequiredError('moveSheetRowRequest', 'Required parameter requestParameters.moveSheetRowRequest was null or undefined when calling move.');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        headerParameters['Content-Type'] = 'application/json';
                        return [4 /*yield*/, this.request({
                                path: "/sheetRows/{sheetRowId}/move".replace("{".concat('sheetRowId', "}"), encodeURIComponent(String(requestParameters.sheetRowId))),
                                method: 'POST',
                                headers: headerParameters,
                                query: queryParameters,
                                body: MoveSheetRowRequestToJSON(requestParameters.moveSheetRowRequest),
                            })];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.VoidApiResponse(response)];
                }
            });
        });
    };
    /**
     * Sort sheetRows
     */
    SheetRowsApi.prototype.move = function (sheetRowId, moveSheetRowRequest) {
        return __awaiter(this, void 0, Promise, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.moveRaw({ sheetRowId: sheetRowId, moveSheetRowRequest: moveSheetRowRequest })];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    /**
     * search sheet row hierarchy
     */
    SheetRowsApi.prototype.searchRaw = function (requestParameters) {
        return __awaiter(this, void 0, Promise, function () {
            var queryParameters, headerParameters, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.searchSheetRowHierarchyRequest === null ||
                            requestParameters.searchSheetRowHierarchyRequest === undefined) {
                            throw new runtime.RequiredError('searchSheetRowHierarchyRequest', 'Required parameter requestParameters.searchSheetRowHierarchyRequest was null or undefined when calling search.');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        headerParameters['Content-Type'] = 'application/json';
                        return [4 /*yield*/, this.request({
                                path: "/sheetRows/search",
                                method: 'POST',
                                headers: headerParameters,
                                query: queryParameters,
                                body: SearchSheetRowHierarchyRequestToJSON(requestParameters.searchSheetRowHierarchyRequest),
                            })];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) {
                                return SearchSheetRowSearchResultRepresentationFromJSON(jsonValue);
                            })];
                }
            });
        });
    };
    /**
     * search sheet row hierarchy
     */
    SheetRowsApi.prototype.search = function (searchSheetRowHierarchyRequest) {
        return __awaiter(this, void 0, Promise, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.searchRaw({ searchSheetRowHierarchyRequest: searchSheetRowHierarchyRequest })];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Update sheet row
     */
    SheetRowsApi.prototype.updateRaw = function (requestParameters) {
        return __awaiter(this, void 0, Promise, function () {
            var queryParameters, headerParameters, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.sheetRowId === null || requestParameters.sheetRowId === undefined) {
                            throw new runtime.RequiredError('sheetRowId', 'Required parameter requestParameters.sheetRowId was null or undefined when calling update.');
                        }
                        if (requestParameters.updateSheetRowRequest === null || requestParameters.updateSheetRowRequest === undefined) {
                            throw new runtime.RequiredError('updateSheetRowRequest', 'Required parameter requestParameters.updateSheetRowRequest was null or undefined when calling update.');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        headerParameters['Content-Type'] = 'application/json';
                        return [4 /*yield*/, this.request({
                                path: "/sheetRows/{sheetRowId}".replace("{".concat('sheetRowId', "}"), encodeURIComponent(String(requestParameters.sheetRowId))),
                                method: 'PUT',
                                headers: headerParameters,
                                query: queryParameters,
                                body: UpdateSheetRowRequestToJSON(requestParameters.updateSheetRowRequest),
                            })];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.VoidApiResponse(response)];
                }
            });
        });
    };
    /**
     * Update sheet row
     */
    SheetRowsApi.prototype.update = function (sheetRowId, updateSheetRowRequest) {
        return __awaiter(this, void 0, Promise, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.updateRaw({ sheetRowId: sheetRowId, updateSheetRowRequest: updateSheetRowRequest })];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    return SheetRowsApi;
}(runtime.BaseAPI));
export { SheetRowsApi };
